import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IGetHomework, IGetTeacherListByHomework, IHomeWorkServiceResponse, IHomeworkSubject } from '../models/homework.model';
import { ITableDataApiRes } from '../models/http.model';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class HomeworkService {
  constructor(private httpService: HttpService) { }

  postHomework(bodyData: any): Observable<any> {
    return this.httpService.post('/student/home-work', bodyData);
  }

  getTeacherListByHomeworkId(
    homeworkId: string,
    params: IGetTeacherListByHomework = { page: 1, limit: 10 }
  ): Observable<ITableDataApiRes> {
    return this.httpService.get(`/student/home-work/${homeworkId}/teachers`, params);
  }

  postAskToTeacher(homeworkId: string, teacherId: string): Observable<any> {
    return this.httpService.post(`/student/home-work/${homeworkId}/ask/${teacherId}`);
  }

  cancelAsk(homeworkId: string, teacherId: string): Observable<any> {
    return this.httpService.post(`/student/home-work/${homeworkId}/reject/${teacherId}`);
  }

  confirmAsk(homeworkId: string, teacherId: string): Observable<any> {
    return this.httpService.post(`/student/home-work/${homeworkId}/confirm/${teacherId}`);
  }

  getAnswerHomework(homeworkId: string): Observable<any> {
    return this.httpService.get(`/student/home-work/${homeworkId}`);
  }

  getHomework(params: IGetHomework = { page: 1, limit: 10 }): Observable<ITableDataApiRes> {
    return this.httpService.get('/student/home-work', params);
  }

  getHomeworkSubject(): Observable<IHomeworkSubject[]> {
    return this.httpService.get('/student/home-work/subject');
  }

  getHomeworkDetail(id: string): Observable<IHomeWorkServiceResponse> {
    return this.httpService.get('/student/home-work/public/' + id);
  }
}
